<template>
  <div>
    <div
        class="button-ground jy-common-fujian-button-zu displayFlex"
        v-if="!disabled"
    >
      <uploadimgs
          @input="changeFileList"
          :showList="false"
          :showBtns="showBtns"
          :fileNameLists="fileNameLists"
          :limit="0"
          listType="picture"
      ></uploadimgs>

      <el-button
          v-if="addFiles"
          @click="saveImgs"
          style="margin-left: 30px"
          size="large"
          type="primary"
      >保存新增</el-button
      >
    </div>
    <div
        class="table-ground jy-common-fujian-table-zu"
        :style="disabled ? 'margin-top: 5px' : 'margin-top: 20px'"
    >
      <el-table
          class="jy-common-table"
          header-align="center"
          border
          stripe
          :highlight-current-row="true"
          style="width: 100%"
          :data="annexTable"
      >
        <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
        ></el-table-column>

        <el-table-column
            class-name="jy-required"
            align="center"
            prop="fileName"
            label="附件名称"
        >
          <template #default="scope">
            <el-input
                type="text"
                v-model="scope.row.fileName"
                @change="pushAnnexTable"
                placeholder="请输入"
            >
            </el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fileType" label="文件类型">
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="上传时间">
        </el-table-column>
        <el-table-column align="center" prop="operationUserName" label="操作人">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="180">
          <template #default="scope">
            <el-popconfirm
                title="确定删除该附件吗"
                @confirm="onDelAnnexTable(scope.$index)"
                v-if="!disabled && delFilse"
            >
              <template #reference>
                <el-button link>删除</el-button>
              </template>
            </el-popconfirm>
            <el-button link @click="onViewAnnex(scope)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Api }  from "@/assets/js/api";
import utils from "@/assets/js/tool";
import uploadimgs from "@/components/uploadImgs/index.vue";

export default {
  name: "FuJian",
  components: { uploadimgs },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showBtns: {
      type: Boolean,
      default: true,
    },
    delFilse: {
      type: Boolean,
      default: true,
    },
    addFiles: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    DELFiles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      annexTable: [],
      fileNameLists: [],
      DELFilesList: []
    };
  },
  watch: {

    data: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          this.annexTable = [...newValue];
        } else {
          this.annexTable = [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeFileList(array) {
      if (utils.jyCheckObjectType(array) === "Array") {
        this.fileNameLists = array;
        array.forEach((item) => {
          if (item.name) {
            const exists = this.annexTable.some(itm => itm.fileName === item.fileName);
            if (!exists) {
              const obj = {
                url: item.url,
                fileName: item.fileName || item.name,
                fileId: item.name,
                fileType: "自动获取",
                createTime: "自动获取",
                operationUserName: "自动获取",
                operationType: "ADD",
              };
              this.annexTable.push(obj);
            }
          }
        });
        this.$emit("pushAnnexTable", this.annexTable);
      }
    },
    onDelAnnexTable(idx) {
      if (this.annexTable[idx].operationType !== "ADD") {
        this.annexTable[idx].operationType = "DEL";
        this.DELFilesList.push(this.annexTable[idx]);
      }
      this.annexTable.splice(idx, 1);
      this.$emit("DElAnnexTable", this.DELFilesList);
    },
    pushAnnexTable() {
      this.$emit("pushAnnexTable", this.annexTable);
    },
    onViewAnnex(row) {
      const item = row.row;
      if (item.fileId) {
        Api.getFileUrl({ fileName: item.fileId }).then((res) => {
          const filse = res.data.result || {};
          if (filse.url) {
            window.open(filse.url, "_blank");
          } else {
            this.$message.error("打开失败,没有检测到图片地址");
          }
        });
      } else {
        this.$message.error("附件ID不存在！");
      }
    },
    downLoads(row) {
      const item = row.row;
      if (item.fileId) {
        Api.getFileUrl({ fileName: item.fileId }).then((res) => {
          const filse = res.data.result || {};
          if (filse.url) {
            const a = document.createElement('a');
            a.href = filse.url;
            a.download = item.fileName || "download";
            a.click();
          } else {
            this.$message.error("下载失败,没有检测到文件地址");
          }
        });
      } else {
        this.$message.error("附件ID不存在！");
      }
    },
    saveImgs() {
      this.$emit("saveFile", this.annexTable);
    }
  }
};
</script>

<style lang="scss" scoped>
.displayFlex {
  display: flex;
  align-items: center;
}
</style>
